import { defineComponent } from 'vue';
import { prepareComponentOptions, useController } from 'zova';
import { ControllerBehavior } from '../../component/behavior/controller.jsx';
export const ZBehavior = defineComponent(_props => {
  useController(ControllerBehavior, undefined, undefined);
  return () => {};
}, prepareComponentOptions(ControllerBehavior.$componentOptions));